export default __webpack_public_path__ + "f02b4776061e1b168138aa781c562215.png";